import { render, staticRenderFns } from "./dashboardServiceArea.vue?vue&type=template&id=0d6e48e8"
import script from "./dashboardServiceArea.vue?vue&type=script&lang=js"
export * from "./dashboardServiceArea.vue?vue&type=script&lang=js"
import style0 from "./dashboardServiceArea.vue?vue&type=style&index=0&id=0d6e48e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports